import React from 'react';
import { ConditionEditorProps } from './interface';
import { StyledSectionHeader, StyledSectionTitle } from '../../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import styled from 'styled-components';
import useClinicById from '../../hooks/useClinicById';
import { useConditionTitle } from '../tabs/ClinicConditionsTab/useConditionTitle';

interface ConditionEditorHeaderProps extends Pick<ConditionEditorProps, 'condition' | 'form' | 'index' | 'clinicId'> {}

const ConditionEditorHeader = ({ condition, form, index, clinicId }: ConditionEditorHeaderProps) => {
  const title = useConditionTitle(condition);
  const clinicCondition = form.watch(`clinic_conditions.${index}`);
  const { clinic } = useClinicById(clinicCondition?.clinic_id || '');
  const isFromAnotherClinic = Boolean(clinicCondition?.clinic_id && clinicCondition.clinic_id !== clinicId);

  return (
    <StyledSectionHeader>
      <div>
        <StyledSectionTitle>{title}</StyledSectionTitle>
        {isFromAnotherClinic && clinic && (
          <ClinicPill>
            {clinic.name}
          </ClinicPill>
        )}
      </div>
    </StyledSectionHeader>
  );
};

const ClinicPill = styled.div`
  background-color: #2f9d6d;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  display: inline-block;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
`;

export default ConditionEditorHeader;
